import { render, staticRenderFns } from "./open-list.vue?vue&type=template&id=4809cf40&scoped=true&"
import script from "./open-list.vue?vue&type=script&lang=js&"
export * from "./open-list.vue?vue&type=script&lang=js&"
import style0 from "./open-list.vue?vue&type=style&index=0&id=4809cf40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4809cf40",
  null
  
)

export default component.exports